/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ProtectedIndexRouteImport } from './routes/_protected.index'
import { Route as ProtectedWorkflowsRouteImport } from './routes/_protected.workflows'
import { Route as ProtectedStudioRouteImport } from './routes/_protected.studio'
import { Route as ProtectedRunsRouteImport } from './routes/_protected.runs'
import { Route as ProtectedProfileRouteImport } from './routes/_protected.profile'
import { Route as ProtectedKnowledgeRouteImport } from './routes/_protected.knowledge'
import { Route as ProtectedDataRouteImport } from './routes/_protected.data'
import { Route as ProtectedDashboardPersonalRouteImport } from './routes/_protected.dashboard-personal'
import { Route as ProtectedWorkflowsIndexRouteImport } from './routes/_protected.workflows.index'
import { Route as ProtectedStudioIndexRouteImport } from './routes/_protected.studio.index'
import { Route as ProtectedKnowledgeIndexRouteImport } from './routes/_protected.knowledge.index'
import { Route as ProtectedWorkflowsAgentIdRouteImport } from './routes/_protected.workflows.$agentId'
import { Route as ProtectedStudioNewRouteImport } from './routes/_protected.studio.new'
import { Route as ProtectedStudioBuildRouteImport } from './routes/_protected.studio.build'
import { Route as ProtectedStudioWorkflowIdRouteImport } from './routes/_protected.studio.$workflowId'
import { Route as ProtectedRunsRunIdRouteImport } from './routes/_protected.runs.$runId'
import { Route as ProtectedWorkflowsNewAgentIdRouteImport } from './routes/_protected.workflows.new.$agentId'
import { Route as ProtectedRunsNewAgentIdRouteImport } from './routes/_protected.runs.new.$agentId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWorkflowsRoute = ProtectedWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedStudioRoute = ProtectedStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedRunsRoute = ProtectedRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedKnowledgeRoute = ProtectedKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDataRoute = ProtectedDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardPersonalRoute =
  ProtectedDashboardPersonalRouteImport.update({
    id: '/dashboard-personal',
    path: '/dashboard-personal',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWorkflowsIndexRoute = ProtectedWorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedWorkflowsRoute,
} as any)
const ProtectedStudioIndexRoute = ProtectedStudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedStudioRoute,
} as any)
const ProtectedKnowledgeIndexRoute = ProtectedKnowledgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedKnowledgeRoute,
} as any)
const ProtectedWorkflowsAgentIdRoute =
  ProtectedWorkflowsAgentIdRouteImport.update({
    id: '/$agentId',
    path: '/$agentId',
    getParentRoute: () => ProtectedWorkflowsRoute,
  } as any)
const ProtectedStudioNewRoute = ProtectedStudioNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProtectedStudioRoute,
} as any)
const ProtectedStudioBuildRoute = ProtectedStudioBuildRouteImport.update({
  id: '/build',
  path: '/build',
  getParentRoute: () => ProtectedStudioRoute,
} as any)
const ProtectedStudioWorkflowIdRoute =
  ProtectedStudioWorkflowIdRouteImport.update({
    id: '/$workflowId',
    path: '/$workflowId',
    getParentRoute: () => ProtectedStudioRoute,
  } as any)
const ProtectedRunsRunIdRoute = ProtectedRunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => ProtectedRunsRoute,
} as any)
const ProtectedWorkflowsNewAgentIdRoute =
  ProtectedWorkflowsNewAgentIdRouteImport.update({
    id: '/new/$agentId',
    path: '/new/$agentId',
    getParentRoute: () => ProtectedWorkflowsRoute,
  } as any)
const ProtectedRunsNewAgentIdRoute = ProtectedRunsNewAgentIdRouteImport.update({
  id: '/new/$agentId',
  path: '/new/$agentId',
  getParentRoute: () => ProtectedRunsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof ProtectedIndexRoute
  '/login': typeof LoginRoute
  '/dashboard-personal': typeof ProtectedDashboardPersonalRoute
  '/data': typeof ProtectedDataRoute
  '/knowledge': typeof ProtectedKnowledgeRouteWithChildren
  '/profile': typeof ProtectedProfileRoute
  '/runs': typeof ProtectedRunsRouteWithChildren
  '/studio': typeof ProtectedStudioRouteWithChildren
  '/workflows': typeof ProtectedWorkflowsRouteWithChildren
  '/runs/$runId': typeof ProtectedRunsRunIdRoute
  '/studio/$workflowId': typeof ProtectedStudioWorkflowIdRoute
  '/studio/build': typeof ProtectedStudioBuildRoute
  '/studio/new': typeof ProtectedStudioNewRoute
  '/workflows/$agentId': typeof ProtectedWorkflowsAgentIdRoute
  '/knowledge/': typeof ProtectedKnowledgeIndexRoute
  '/studio/': typeof ProtectedStudioIndexRoute
  '/workflows/': typeof ProtectedWorkflowsIndexRoute
  '/runs/new/$agentId': typeof ProtectedRunsNewAgentIdRoute
  '/workflows/new/$agentId': typeof ProtectedWorkflowsNewAgentIdRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/dashboard-personal': typeof ProtectedDashboardPersonalRoute
  '/data': typeof ProtectedDataRoute
  '/profile': typeof ProtectedProfileRoute
  '/runs': typeof ProtectedRunsRouteWithChildren
  '/': typeof ProtectedIndexRoute
  '/runs/$runId': typeof ProtectedRunsRunIdRoute
  '/studio/$workflowId': typeof ProtectedStudioWorkflowIdRoute
  '/studio/build': typeof ProtectedStudioBuildRoute
  '/studio/new': typeof ProtectedStudioNewRoute
  '/workflows/$agentId': typeof ProtectedWorkflowsAgentIdRoute
  '/knowledge': typeof ProtectedKnowledgeIndexRoute
  '/studio': typeof ProtectedStudioIndexRoute
  '/workflows': typeof ProtectedWorkflowsIndexRoute
  '/runs/new/$agentId': typeof ProtectedRunsNewAgentIdRoute
  '/workflows/new/$agentId': typeof ProtectedWorkflowsNewAgentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/_protected/dashboard-personal': typeof ProtectedDashboardPersonalRoute
  '/_protected/data': typeof ProtectedDataRoute
  '/_protected/knowledge': typeof ProtectedKnowledgeRouteWithChildren
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/runs': typeof ProtectedRunsRouteWithChildren
  '/_protected/studio': typeof ProtectedStudioRouteWithChildren
  '/_protected/workflows': typeof ProtectedWorkflowsRouteWithChildren
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/runs/$runId': typeof ProtectedRunsRunIdRoute
  '/_protected/studio/$workflowId': typeof ProtectedStudioWorkflowIdRoute
  '/_protected/studio/build': typeof ProtectedStudioBuildRoute
  '/_protected/studio/new': typeof ProtectedStudioNewRoute
  '/_protected/workflows/$agentId': typeof ProtectedWorkflowsAgentIdRoute
  '/_protected/knowledge/': typeof ProtectedKnowledgeIndexRoute
  '/_protected/studio/': typeof ProtectedStudioIndexRoute
  '/_protected/workflows/': typeof ProtectedWorkflowsIndexRoute
  '/_protected/runs/new/$agentId': typeof ProtectedRunsNewAgentIdRoute
  '/_protected/workflows/new/$agentId': typeof ProtectedWorkflowsNewAgentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/login'
    | '/dashboard-personal'
    | '/data'
    | '/knowledge'
    | '/profile'
    | '/runs'
    | '/studio'
    | '/workflows'
    | '/runs/$runId'
    | '/studio/$workflowId'
    | '/studio/build'
    | '/studio/new'
    | '/workflows/$agentId'
    | '/knowledge/'
    | '/studio/'
    | '/workflows/'
    | '/runs/new/$agentId'
    | '/workflows/new/$agentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/login'
    | '/dashboard-personal'
    | '/data'
    | '/profile'
    | '/runs'
    | '/'
    | '/runs/$runId'
    | '/studio/$workflowId'
    | '/studio/build'
    | '/studio/new'
    | '/workflows/$agentId'
    | '/knowledge'
    | '/studio'
    | '/workflows'
    | '/runs/new/$agentId'
    | '/workflows/new/$agentId'
  id:
    | '__root__'
    | '/$'
    | '/_protected'
    | '/login'
    | '/_protected/dashboard-personal'
    | '/_protected/data'
    | '/_protected/knowledge'
    | '/_protected/profile'
    | '/_protected/runs'
    | '/_protected/studio'
    | '/_protected/workflows'
    | '/_protected/'
    | '/_protected/runs/$runId'
    | '/_protected/studio/$workflowId'
    | '/_protected/studio/build'
    | '/_protected/studio/new'
    | '/_protected/workflows/$agentId'
    | '/_protected/knowledge/'
    | '/_protected/studio/'
    | '/_protected/workflows/'
    | '/_protected/runs/new/$agentId'
    | '/_protected/workflows/new/$agentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/workflows': {
      id: '/_protected/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof ProtectedWorkflowsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/studio': {
      id: '/_protected/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof ProtectedStudioRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/runs': {
      id: '/_protected/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof ProtectedRunsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/knowledge': {
      id: '/_protected/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof ProtectedKnowledgeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/data': {
      id: '/_protected/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof ProtectedDataRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard-personal': {
      id: '/_protected/dashboard-personal'
      path: '/dashboard-personal'
      fullPath: '/dashboard-personal'
      preLoaderRoute: typeof ProtectedDashboardPersonalRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/workflows/': {
      id: '/_protected/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof ProtectedWorkflowsIndexRouteImport
      parentRoute: typeof ProtectedWorkflowsRoute
    }
    '/_protected/studio/': {
      id: '/_protected/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof ProtectedStudioIndexRouteImport
      parentRoute: typeof ProtectedStudioRoute
    }
    '/_protected/knowledge/': {
      id: '/_protected/knowledge/'
      path: '/'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof ProtectedKnowledgeIndexRouteImport
      parentRoute: typeof ProtectedKnowledgeRoute
    }
    '/_protected/workflows/$agentId': {
      id: '/_protected/workflows/$agentId'
      path: '/$agentId'
      fullPath: '/workflows/$agentId'
      preLoaderRoute: typeof ProtectedWorkflowsAgentIdRouteImport
      parentRoute: typeof ProtectedWorkflowsRoute
    }
    '/_protected/studio/new': {
      id: '/_protected/studio/new'
      path: '/new'
      fullPath: '/studio/new'
      preLoaderRoute: typeof ProtectedStudioNewRouteImport
      parentRoute: typeof ProtectedStudioRoute
    }
    '/_protected/studio/build': {
      id: '/_protected/studio/build'
      path: '/build'
      fullPath: '/studio/build'
      preLoaderRoute: typeof ProtectedStudioBuildRouteImport
      parentRoute: typeof ProtectedStudioRoute
    }
    '/_protected/studio/$workflowId': {
      id: '/_protected/studio/$workflowId'
      path: '/$workflowId'
      fullPath: '/studio/$workflowId'
      preLoaderRoute: typeof ProtectedStudioWorkflowIdRouteImport
      parentRoute: typeof ProtectedStudioRoute
    }
    '/_protected/runs/$runId': {
      id: '/_protected/runs/$runId'
      path: '/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof ProtectedRunsRunIdRouteImport
      parentRoute: typeof ProtectedRunsRoute
    }
    '/_protected/workflows/new/$agentId': {
      id: '/_protected/workflows/new/$agentId'
      path: '/new/$agentId'
      fullPath: '/workflows/new/$agentId'
      preLoaderRoute: typeof ProtectedWorkflowsNewAgentIdRouteImport
      parentRoute: typeof ProtectedWorkflowsRoute
    }
    '/_protected/runs/new/$agentId': {
      id: '/_protected/runs/new/$agentId'
      path: '/new/$agentId'
      fullPath: '/runs/new/$agentId'
      preLoaderRoute: typeof ProtectedRunsNewAgentIdRouteImport
      parentRoute: typeof ProtectedRunsRoute
    }
  }
}

interface ProtectedKnowledgeRouteChildren {
  ProtectedKnowledgeIndexRoute: typeof ProtectedKnowledgeIndexRoute
}

const ProtectedKnowledgeRouteChildren: ProtectedKnowledgeRouteChildren = {
  ProtectedKnowledgeIndexRoute: ProtectedKnowledgeIndexRoute,
}

const ProtectedKnowledgeRouteWithChildren =
  ProtectedKnowledgeRoute._addFileChildren(ProtectedKnowledgeRouteChildren)

interface ProtectedRunsRouteChildren {
  ProtectedRunsRunIdRoute: typeof ProtectedRunsRunIdRoute
  ProtectedRunsNewAgentIdRoute: typeof ProtectedRunsNewAgentIdRoute
}

const ProtectedRunsRouteChildren: ProtectedRunsRouteChildren = {
  ProtectedRunsRunIdRoute: ProtectedRunsRunIdRoute,
  ProtectedRunsNewAgentIdRoute: ProtectedRunsNewAgentIdRoute,
}

const ProtectedRunsRouteWithChildren = ProtectedRunsRoute._addFileChildren(
  ProtectedRunsRouteChildren,
)

interface ProtectedStudioRouteChildren {
  ProtectedStudioWorkflowIdRoute: typeof ProtectedStudioWorkflowIdRoute
  ProtectedStudioBuildRoute: typeof ProtectedStudioBuildRoute
  ProtectedStudioNewRoute: typeof ProtectedStudioNewRoute
  ProtectedStudioIndexRoute: typeof ProtectedStudioIndexRoute
}

const ProtectedStudioRouteChildren: ProtectedStudioRouteChildren = {
  ProtectedStudioWorkflowIdRoute: ProtectedStudioWorkflowIdRoute,
  ProtectedStudioBuildRoute: ProtectedStudioBuildRoute,
  ProtectedStudioNewRoute: ProtectedStudioNewRoute,
  ProtectedStudioIndexRoute: ProtectedStudioIndexRoute,
}

const ProtectedStudioRouteWithChildren = ProtectedStudioRoute._addFileChildren(
  ProtectedStudioRouteChildren,
)

interface ProtectedWorkflowsRouteChildren {
  ProtectedWorkflowsAgentIdRoute: typeof ProtectedWorkflowsAgentIdRoute
  ProtectedWorkflowsIndexRoute: typeof ProtectedWorkflowsIndexRoute
  ProtectedWorkflowsNewAgentIdRoute: typeof ProtectedWorkflowsNewAgentIdRoute
}

const ProtectedWorkflowsRouteChildren: ProtectedWorkflowsRouteChildren = {
  ProtectedWorkflowsAgentIdRoute: ProtectedWorkflowsAgentIdRoute,
  ProtectedWorkflowsIndexRoute: ProtectedWorkflowsIndexRoute,
  ProtectedWorkflowsNewAgentIdRoute: ProtectedWorkflowsNewAgentIdRoute,
}

const ProtectedWorkflowsRouteWithChildren =
  ProtectedWorkflowsRoute._addFileChildren(ProtectedWorkflowsRouteChildren)

interface ProtectedRouteChildren {
  ProtectedDashboardPersonalRoute: typeof ProtectedDashboardPersonalRoute
  ProtectedDataRoute: typeof ProtectedDataRoute
  ProtectedKnowledgeRoute: typeof ProtectedKnowledgeRouteWithChildren
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedRunsRoute: typeof ProtectedRunsRouteWithChildren
  ProtectedStudioRoute: typeof ProtectedStudioRouteWithChildren
  ProtectedWorkflowsRoute: typeof ProtectedWorkflowsRouteWithChildren
  ProtectedIndexRoute: typeof ProtectedIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardPersonalRoute: ProtectedDashboardPersonalRoute,
  ProtectedDataRoute: ProtectedDataRoute,
  ProtectedKnowledgeRoute: ProtectedKnowledgeRouteWithChildren,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedRunsRoute: ProtectedRunsRouteWithChildren,
  ProtectedStudioRoute: ProtectedStudioRouteWithChildren,
  ProtectedWorkflowsRoute: ProtectedWorkflowsRouteWithChildren,
  ProtectedIndexRoute: ProtectedIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
